import React from "react"
import { StudioManager } from "../../studio-manager";

export class Player extends React.Component {
  constructor () {
    super();
    this.state = { available: false, playing: false, unmuted: false };
  }

  componentDidMount () {
    StudioManager.instance.on('stream-online', this.startStream);
  }

  startStream = () => {
    if (this.state.available) return;

    console.log('Starting Stream');
    this.setState({ available: true });
    this.player = window.videojs('vjs');
    this.player.play();
    this.player.one('loadeddata', this.firstPlay);
  }

  firstPlay = () => {
    this.setState({ playing: true });
  }

  unmute = () => {
    this.setState({ unmuted: true });
    this.player.muted(false);
  }

  get style () {
    var _ = 'player';
    if (this.state.available) _ += ' player--available';
    if (this.state.playing) _ += ' player--playing';
    if (this.state.unmuted) _ += ' player--unmuted';
    return _;
  }

  render () {
    return (
      <div className={this.style} ref={_ => this.dom = _} onClick={this.unmute}>
        { !this.state.playing && <div className="player__loading">... stream is loading ...</div> }
        <video id="vjs" muted playsInline controls={this.state.playing && this.state.unmuted}>
          <source src={StudioManager.instance.streamUrl} type="application/x-mpegURL" />
        </video>
        { (this.state.playing && !this.state.unmuted) && <div className="player__unmute">CLICK TO LISTEN</div> }
      </div>
    )
  }
}
